import React, { Component } from 'react';
import { connect } from 'react-redux';
import Aux from 'react-aux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import classes from './Statistics.module.css';
import Select from '../../components/UI/Select/Select';
// import CloseButton from '../../components/UI/Buttons/CloseButton';
// import Spinner from '../../components/Spinner/Spinner';
import Button from '../../components/UI/Buttons/Button';
import Chart from '../../components/Chart/Chart';
import DataTable from '../../components/UI/DataTable/DataTable';
import Spinner from '../../components/Spinner/Spinner';
import * as actions from '../../store/actions/index';

class Statistics extends Component {
    
    state={
        adminRegions:[
            {value: "country", label:"Επικράτεια", nameField:"", codeField:""},
            {value: "nuts1", label:"Μεγάλη Γεωγραφική Περιοχή (NUTS1)", nameField:"n1_name4el", codeField:"n1_code"},
            {value: "nuts2", label:"Περιφέρεια (NUTS2)", nameField:"n2_name4el", codeField:"n2_code"},
            {value: "nuts3", label:"Περιφερειακή Ενότητα (NUTS3)", nameField:"n3_name4el", codeField:"n3_code"},
            {value: "lau1", label:"Δήμος/Κοινότητα (LAU1)", nameField:"l1_name1el", codeField:"l1_code"}
        ]
    }

    componentDidMount () {
        // Run only if there are no results data (which means it is the first time loading this tab)
        if (this.props.statsFires.results.data.length === 0){
            this.props.onGetStatistics(this.props.geoserverUrl, "country", null, this.props.selectedStatsType, "");
        }
    }

    onChangeAdmin (value) {
        if (value !== this.props.selectedAdmin){
            const adminRegion = this.state.adminRegions.filter(x => x.value === value)[0];

            if (value !== "country"){
                this.props.onGetAdminWithFires(this.props.geoserverUrl, value, adminRegion.nameField, adminRegion.codeField);

            } else {
                this.props.onGetStatistics(this.props.geoserverUrl, value, this.props.selectedAdminItem, this.props.selectedStatsType, adminRegion.codeField);
            }

            this.props.onUpdateSimpleVariable("selectedAdmin",value);
            this.props.onUpdateSimpleVariable("selectedAdminLabel",adminRegion.label);
        }
    }

    onChangeAdminItem (value){
        if (value !== this.props.selectedAdminItem){
            this.props.onUpdateSimpleVariable("selectedAdminItem",value);
        }

        const adminRegion = this.state.adminRegions.filter(x => x.value === this.props.selectedAdmin)[0];
        this.props.onGetStatistics(this.props.geoserverUrl, this.props.selectedAdmin, value, this.props.selectedStatsType, adminRegion.codeField);
    }

    onChangeStatsType(statsType){
        this.props.onUpdateSimpleVariable("selectedStatsType",statsType);

        const adminRegion = this.state.adminRegions.filter(x => x.value === this.props.selectedAdmin)[0];
        this.props.onGetStatistics(this.props.geoserverUrl, this.props.selectedAdmin, this.props.selectedAdminItem, statsType, adminRegion.codeField);
    }

    render () {
        return(
            <div className={classes.StatisticsWrapper}>
                <h4>Διοικητική Ενότητα</h4>
                <div className={classes.RegionSelection}>
                    <Select 
                        classes={classes.SelectWrapper}
                        placeholder="Δοικητική Ενότητα"
                        options={this.state.adminRegions}
                        defaultValue={this.props.selectedAdmin}
                        changed={(value) => this.onChangeAdmin(value)}
                    />

                    {this.props.selectedAdmin !== "country" ? 
                        <div className={classes.SelectWithSpinner}>
                            <Select 
                                classes={classes.SelectWrapper}
                                placeholder={this.props.selectedAdminLabel}
                                options={this.props.adminItems}
                                defaultValue={this.props.selectedAdminItem} //TODO: not working. Doesn't take first value as default
                                changed={(value) => this.onChangeAdminItem(value)}
                                disabled={this.props.adminItemsLoading}
                            />
                            {this.props.adminItemsLoading ?
                                <div className={classes.SelectSpinnerWrapper}>
                                    <Spinner />
                                </div> 
                                : null
                            }
                        </div>
                    : null}
                </div>
                
                <div className={classes.ButtonsWrapper}>
                    <Button active={this.props.selectedStatsType === "fires"} clicked={() => this.onChangeStatsType("fires")}>
                        <div>
                            <span>Αριθμός και έκταση πυρκαγιών</span>
                        </div>
                    </Button>

                    <Button active={this.props.selectedStatsType === "clc"} clicked={() => this.onChangeStatsType("clc")}>
                        <div>
                            <span>Χρήσεις γης</span>
                        </div>
                    </Button>
                </div>

                <div className={classes.ChartWrapper}>
                    {this.props.selectedStatsType === "fires" || this.props.statsClcLastYear === 0 ?  null : 
                        <Aux>
                            <h4>Έτος</h4>
                            <div className={classes.RegionSelection}>
                                <Select 
                                    classes={classes.SelectWrapper}
                                    placeholder="Έτος"
                                    options={this.props.statsClcYears}
                                    defaultValue={this.props.statsClcLastYear}
                                    changed={(value) => this.props.onChangeClcYear(value)}
                                />
                            </div>
                        </Aux>
                    }
                    <Tabs defaultIndex = {0}
                        className={classes.Tabs}
                        selectedTabClassName={classes.SelectedTab}
                    >
                        <TabList className={classes.TabList}>
                            <Tab>Έκταση</Tab>
                            {this.props.selectedStatsType === "fires" ? 
                                <Tab>Αριθμός</Tab>
                                : null
                            }
                        </TabList>

                        <TabPanel 
                            className={classes.TabPanel}
                            selectedClassName={classes.SelectedTabPanel}
                        >
                            <Chart 
                                stats={this.props.selectedStatsType === "fires" ?  this.props.statsFires.results : this.props.statsClc.results}
                                xTick={this.props.selectedStatsType === "fires" ? true : false}
                            />
                            <div className={classes.DataTableWrapper}>
                                {this.props.statsFires.results.data.length > 0 ? 
                                    <DataTable tableData={this.props.selectedStatsType === "fires" ?  this.props.statsFires.results : this.props.statsClc.results} />
                                : null}
                            </div>
                            
                        </TabPanel>

                        {this.props.selectedStatsType === "fires" ? 
                            <TabPanel 
                                className={classes.TabPanel}
                                selectedClassName={classes.SelectedTabPanel}
                            >
                                <Chart 
                                    stats={this.props.statsFires.numbers}  
                                />
                                <div className={classes.DataTableWrapper}>
                                    {this.props.statsFires.results.data.length > 0 ? 
                                        <DataTable tableData={this.props.statsFires.numbers} />
                                    : null}
                                </div>
                            </TabPanel>
                            : null
                        }
                    </Tabs>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        geoserverUrl: state.system.geoserverUrl,
        mapBounds: state.webgis.mapBounds,
        adminItems: state.statistics.adminItems,
        statsFires: state.statistics.statsFires,
        statsClc: state.statistics.statsClc,
        selectedAdmin: state.statistics.selectedAdmin,
        selectedAdminItem: state.statistics.selectedAdminItem,
        selectedAdminLabel: state.statistics.selectedAdminLabel,
        selectedStatsType: state.statistics.selectedStatsType,
        statsClcYears: state.statistics.statsClcYears,
        statsClcLastYear: state.statistics.statsClcLastYear,
        adminItemsLoading: state.statistics.adminItemsLoading
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onGetAdminWithFires: (geoserverUrl, table, nameField, codeField) => dispatch(actions.getAdminWithFires(geoserverUrl, table, nameField, codeField)),
        onGetStatistics: (geoserverUrl, table, value, selectedStatsType, codeField) => dispatch(actions.getStatistics(geoserverUrl, table, value, selectedStatsType, codeField)),
        onUpdateSimpleVariable: (variableName, newValue) => dispatch(actions.updateSimpleVariable(variableName, newValue)),
        onChangeClcYear: (year) => dispatch(actions.changeClcYear(year))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);